
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-generator/[[...slug]]",
      function () {
        return require("private-next-pages/image-generator/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-generator/[[...slug]]"])
      });
    }
  